module.exports = __webpack_public_path__ + "static/img/Plano1.e3585ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/Plano1.png
// module id = 6EPe
// module chunks = 0